module.exports = __webpack_public_path__ + "static/media/meg sarah.d9f5458e.jpeg";